/**
 * Lightweight analytics wrapper for GA4 + Meta Pixel.
 * Both are OFF by default; activate by setting REACT_APP_GA4_ID / REACT_APP_META_PIXEL_ID
 * in frontend/.env. Uses standard gtag & fbq globals injected in public/index.html at runtime.
 */

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let bootstrapped = false;

export function bootstrapTracking() {
  if (bootstrapped) return;
  bootstrapped = true;

  // GA4
  if (GA4_ID) {
    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s1);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { anonymize_ip: true });
  }

  // Meta Pixel
  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

const GA_EVENT_MAP = {
  view_item: "view_item",
  add_to_cart: "add_to_cart",
  remove_from_cart: "remove_from_cart",
  begin_checkout: "begin_checkout",
  purchase: "purchase",
  sign_up: "sign_up",
  login: "login",
  view_page: "page_view",
};
const META_EVENT_MAP = {
  view_item: "ViewContent",
  add_to_cart: "AddToCart",
  remove_from_cart: null,
  begin_checkout: "InitiateCheckout",
  purchase: "Purchase",
  sign_up: "CompleteRegistration",
  login: null,
  view_page: "PageView",
};

/** Fires a normalized event on GA4 and Meta Pixel (if configured). Safe no-op otherwise. */
export function track(event, params = {}) {
  try {
    if (GA4_ID && window.gtag) {
      const gaEv = GA_EVENT_MAP[event] || event;
      window.gtag("event", gaEv, params);
    }
    if (PIXEL_ID && window.fbq) {
      const fbEv = META_EVENT_MAP[event];
      if (fbEv) window.fbq("track", fbEv, params);
    }
  } catch { /* silent */ }
}

/** Convenience for route changes */
export function trackPageView(path) {
  try {
    if (GA4_ID && window.gtag) window.gtag("event", "page_view", { page_path: path });
    if (PIXEL_ID && window.fbq) window.fbq("track", "PageView");
  } catch { /* silent */ }
}
